/**
 * shadcn/ui Checkbox component (minimal implementation without Radix UI)
 * Visual-only checkbox using native input[type=checkbox]
 */

import * as React from "react"
import { cn } from "@/lib/utils"

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  checked?: boolean
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, checked, ...props }, ref) => (
    <input
      type="checkbox"
      ref={ref}
      checked={checked}
      readOnly={checked !== undefined && !props.onChange}
      className={cn(
        "peer h-4 w-4 shrink-0 rounded-none border-2 border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 accent-primary",
        className
      )}
      {...props}
    />
  )
)
Checkbox.displayName = "Checkbox"

export { Checkbox }
